'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "currencyCode", "error", "numberDisplayHint", "onChange", "onBlur", "showCurrencySymbol", "value"];
import { UNFORMATTED } from 'customer-data-objects/property/NumberDisplayHint';
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import PropTypes from 'prop-types';
import UICurrencyInput from 'UIComponents/input/UICurrencyInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UINumberInput from 'UIComponents/input/UINumberInput';
import isNumber from 'transmute/isNumber';
import I18n from 'I18n';
import { getTransferableProps } from './filterInputProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const unformattedNumberFormatter = number => isNumber(number) ? `${number}` : '';
const FilterOperatorNumberInput = props => {
  const {
      className,
      currencyCode,
      error,
      numberDisplayHint,
      onChange,
      onBlur,
      showCurrencySymbol,
      value
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const Input = showCurrencySymbol ? UICurrencyInput : UINumberInput;
  const formatter = numberDisplayHint === UNFORMATTED ? unformattedNumberFormatter : undefined;
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(Input, Object.assign({}, getTransferableProps(rest), {
      className: className,
      currency: currencyCode,
      formatter: formatter,
      onBlur: onBlur,
      onChange: onChange,
      value: value
    }))
  });
};
FilterOperatorNumberInput.propTypes = {
  className: PropTypes.string,
  currencyCode: PropTypes.string.isRequired,
  error: FilterOperatorErrorType.isRequired,
  numberDisplayHint: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  showCurrencySymbol: PropTypes.bool.isRequired,
  value: PropTypes.number
};
export default FilterOperatorNumberInput;